import React from 'react';
import { Card } from '@/components/shared/card';
import QuestionResponse from './QuestionResponse';
import { Dimension } from '@/types/readiness';

interface DimensionProps {
  dimension: Dimension;
  answers: Record<number, string>;
  onAnswerChange: (questionIndex: number, value: string) => void;
}

const DimensionAssessment = ({
  dimension,
  answers,
  onAnswerChange,
}: DimensionProps) => {
  console.log('DimensionAssessment render with answers:', answers);
  
  return (
    <Card className="p-8 shadow-lg bg-white">
      <div className="space-y-8">
        <h2 className="text-2xl font-bold text-[#1A1F2C]">{dimension.title}</h2>
        
        <div className="space-y-12">
          {dimension.questions.map((question, idx) => (
            <QuestionResponse
              key={idx}
              question={question}
              value={answers[idx] || ''}
              onChange={(value) => onAnswerChange(idx, value)}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};

export default DimensionAssessment;